"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLoqateApiKey = exports.selectAddressResult = exports.addressSelectionFailed = exports.addressSearch = void 0;
require("whatwg-fetch");
var _extend = _interopRequireDefault(require("lodash/extend"));
var _get = _interopRequireDefault(require("lodash/get"));
var _endpointConstants = require("../../../constants/endpointConstants");
var _address2 = require("../../../utils/address/address");
var _addressActions = require("../address/addressActions");
var _addressSearchActionConstants = require("./addressSearchActionConstants");
var _containerResults = _interopRequireDefault(require("./mocks/containerResults.json"));
var _results = _interopRequireDefault(require("./mocks/results.json"));
var _selectResult = _interopRequireDefault(require("./mocks/selectResult.json"));
var _selectResultCompany = _interopRequireDefault(require("./mocks/selectResultCompany.json"));
var _selectResultGuernsey = _interopRequireDefault(require("./mocks/selectResultGuernsey.json"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // mocks
function getJlpid(jlpid) {
  return {
    JLPID: "".concat(jlpid, "_").concat(Date.now())
  };
}
function getLoqateSearchParams(searchTerm, containerId, apiKey, jlpid) {
  var params = _objectSpread({
    Key: apiKey,
    IsMiddleware: false,
    Origin: 'GB',
    Countries: 'GB',
    Limit: null,
    Language: 'en-gb'
  }, jlpid && getJlpid(jlpid));
  if (searchTerm) {
    (0, _extend["default"])(params, {
      Text: searchTerm
    });
  } else {
    (0, _extend["default"])(params, {
      Container: containerId
    });
  }
  return params;
}
function searchLoqate(params) {
  return window.fetch((0, _endpointConstants.URL_LOQATE_ADDRESS_SEARCH)(params));
}
function selectLoqateAddress(params) {
  return window.fetch((0, _endpointConstants.URL_LOQATE_ADDRESS_SELECT)(params));
}
function getLoqateError(items) {
  return items.length === 1 && items[0].Error ? items[0].Error : undefined;
}
function getActionPrefix(addressSearchInputId) {
  return addressSearchInputId ? "".concat(addressSearchInputId, "_") : '';
}
var handleMockedSearch = function handleMockedSearch(searchTerm, containerId, addressId, addressSearchInputId) {
  var getLoqateMocks = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
  var onLoqateNetworkTimeoutCallback = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {};
  var url = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
  return function (dispatch) {
    var prefix = getActionPrefix(addressSearchInputId);
    if (searchTerm) {
      if (searchTerm === 'error') {
        dispatch({
          type: "".concat(addressId, "_").concat(_addressSearchActionConstants.LOQATE_ADDRESS_SEARCH, ".FAILED")
        });
      } else if (searchTerm === 'timeoutError') {
        dispatch({
          type: "".concat(prefix).concat(_addressSearchActionConstants.LOQATE_ADDRESS_SEARCH, ".TIMEOUT_ERROR")
        });
      } else if (searchTerm === 'networkTimeout') {
        dispatch({
          type: "".concat(prefix).concat(_addressSearchActionConstants.LOQATE_ADDRESS_SEARCH, ".LOADING"),
          isContainer: false
        });
        setTimeout(function () {
          dispatch({
            type: "".concat(prefix).concat(_addressSearchActionConstants.LOQATE_ADDRESS_SEARCH, ".NETWORK_TIMEOUT")
          });
          onLoqateNetworkTimeoutCallback(url);
        }, 3000);
      } else {
        var retrievedMock = getLoqateMocks(searchTerm);
        dispatch({
          type: "".concat(prefix).concat(_addressSearchActionConstants.LOQATE_ADDRESS_SEARCH, ".LOADING"),
          isContainer: false
        });
        var items = retrievedMock ? retrievedMock.Items : _results["default"].Items;
        if (!items || getLoqateError(items)) {
          dispatch({
            type: "".concat(addressId, "_").concat(_addressSearchActionConstants.LOQATE_ADDRESS_SEARCH, ".FAILED"),
            isContainer: false
          });
        } else {
          setTimeout(function () {
            dispatch({
              type: "".concat(prefix).concat(_addressSearchActionConstants.LOQATE_ADDRESS_SEARCH, ".SUCCESS"),
              items: items,
              previousSearchTerm: searchTerm,
              isContainer: false
            });
          }, 1000);
        }
      }
    } else if (containerId) {
      var _retrievedMock = getLoqateMocks(containerId);
      dispatch({
        type: "".concat(prefix).concat(_addressSearchActionConstants.LOQATE_ADDRESS_SEARCH, ".LOADING"),
        isContainer: true
      });
      setTimeout(function () {
        dispatch({
          type: "".concat(prefix).concat(_addressSearchActionConstants.LOQATE_ADDRESS_SEARCH, ".SUCCESS"),
          items: _retrievedMock ? _retrievedMock.Items : _containerResults["default"].Items,
          isContainer: true
        });
      }, 1000);
    } else {
      dispatch({
        type: "".concat(prefix).concat(_addressSearchActionConstants.LOQATE_ADDRESS_SEARCH, ".LOADING")
      });
    }
  };
};
var addressSearch = exports.addressSearch = function addressSearch(_ref) {
  var addressId = _ref.addressId,
    addressSearchInputId = _ref.addressSearchInputId,
    _ref$searchTerm = _ref.searchTerm,
    searchTerm = _ref$searchTerm === void 0 ? null : _ref$searchTerm,
    _ref$containerId = _ref.containerId,
    containerId = _ref$containerId === void 0 ? null : _ref$containerId,
    shouldMock = _ref.shouldMock,
    onLoqateSearchCallback = _ref.onLoqateSearchCallback,
    onLoqateNetworkTimeoutCallback = _ref.onLoqateNetworkTimeoutCallback,
    _ref$getLoqateMocks = _ref.getLoqateMocks,
    getLoqateMocks = _ref$getLoqateMocks === void 0 ? function () {} : _ref$getLoqateMocks,
    jlpid = _ref.jlpid;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch, getState) {
      var stateObjectName, apiKey, params, url, prefix, networkTimeoutDispatch, response, json, items, type, isContainer, error;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            stateObjectName = addressSearchInputId || 'addressSearch';
            apiKey = (0, _get["default"])(getState(), "".concat(stateObjectName, ".apiKey"), '');
            params = getLoqateSearchParams(searchTerm, containerId, apiKey, jlpid);
            url = (0, _endpointConstants.URL_LOQATE_ADDRESS_SEARCH)(params);
            prefix = getActionPrefix(addressSearchInputId);
            if (!shouldMock) {
              _context.next = 9;
              break;
            }
            dispatch(handleMockedSearch(searchTerm, containerId, addressId, addressSearchInputId, getLoqateMocks, onLoqateNetworkTimeoutCallback, url));
            _context.next = 23;
            break;
          case 9:
            dispatch({
              type: "".concat(prefix).concat(_addressSearchActionConstants.LOQATE_ADDRESS_SEARCH, ".LOADING")
            });
            networkTimeoutDispatch = setTimeout(function () {
              dispatch({
                type: "".concat(prefix).concat(_addressSearchActionConstants.LOQATE_ADDRESS_SEARCH, ".NETWORK_TIMEOUT")
              });
              onLoqateNetworkTimeoutCallback(url);
            }, 3000);
            _context.next = 13;
            return searchLoqate(params);
          case 13:
            response = _context.sent;
            clearTimeout(networkTimeoutDispatch);
            _context.next = 17;
            return response.json();
          case 17:
            json = _context.sent;
            items = (0, _get["default"])(json, 'Items');
            isContainer = !!containerId;
            error = getLoqateError(items);
            if (!items || error) {
              if (error === _addressSearchActionConstants.LOQATE_TIMEOUT_ERROR_CODE) {
                dispatch({
                  type: "".concat(prefix).concat(_addressSearchActionConstants.LOQATE_ADDRESS_SEARCH, ".TIMEOUT_ERROR")
                });
              } else {
                type = "".concat(addressId, "_").concat(_addressSearchActionConstants.LOQATE_ADDRESS_SEARCH, ".FAILED");
                dispatch({
                  type: type,
                  isContainer: isContainer
                });
              }
            } else {
              type = "".concat(prefix).concat(_addressSearchActionConstants.LOQATE_ADDRESS_SEARCH, ".SUCCESS");
              dispatch({
                type: type,
                items: items,
                isContainer: isContainer,
                previousSearchTerm: searchTerm
              });
            }
            onLoqateSearchCallback(response, type, json);
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var addressSelectionFailed = exports.addressSelectionFailed = function addressSelectionFailed(addressId) {
  return {
    type: "".concat(addressId, "_").concat(_addressSearchActionConstants.LOQATE_ADDRESS_SELECT, ".FAILED"),
    addressId: addressId
  };
};
var selectAddressResult = exports.selectAddressResult = function selectAddressResult(_ref3) {
  var id = _ref3.id,
    addressId = _ref3.addressId,
    addressSearchInputId = _ref3.addressSearchInputId,
    shouldMock = _ref3.shouldMock,
    validateLoqateAddress = _ref3.validateLoqateAddress,
    onLoqateSearchCallback = _ref3.onLoqateSearchCallback,
    onLoqateNetworkTimeoutCallback = _ref3.onLoqateNetworkTimeoutCallback,
    _ref3$getLoqateMocks = _ref3.getLoqateMocks,
    getLoqateMocks = _ref3$getLoqateMocks === void 0 ? function () {} : _ref3$getLoqateMocks,
    jlpid = _ref3.jlpid,
    replaceGbTerritoryCountryCodes = _ref3.replaceGbTerritoryCountryCodes,
    _ref3$combineExtraAdd = _ref3.combineExtraAddressLines,
    combineExtraAddressLines = _ref3$combineExtraAdd === void 0 ? false : _ref3$combineExtraAdd;
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState) {
      var prefix, retrievedMock, address, isValid, stateObjectName, apiKey, params, url, networkTimeoutDispatch, response, json, items, _address, _isValid;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            prefix = getActionPrefix(addressSearchInputId);
            if (!shouldMock) {
              _context2.next = 5;
              break;
            }
            if (id === 'ERROR') {
              dispatch(addressSelectionFailed(addressId));
            } else {
              retrievedMock = getLoqateMocks(id);
              address = retrievedMock ? retrievedMock.Items[0] : function (containerId) {
                switch (containerId) {
                  case 'GUERNSEY':
                    return _selectResultGuernsey["default"].Items[0];
                  case 'COMPANY':
                    return _selectResultCompany["default"].Items[0];
                  default:
                    return _selectResult["default"].Items[0];
                }
              }(id);
              isValid = true;
              if (typeof validateLoqateAddress === 'function') {
                isValid = validateLoqateAddress(address);
              }
              if (isValid) {
                dispatch({
                  type: "".concat(prefix).concat(_addressSearchActionConstants.LOQATE_ADDRESS_SELECT, ".SUCCESS")
                });
                dispatch((0, _addressActions.selectAddress)({
                  addressId: addressId,
                  address: (0, _address2.mapLoqateAddressValuesToAddress)(address, combineExtraAddressLines),
                  replaceGbTerritoryCountryCodes: replaceGbTerritoryCountryCodes
                }));
              } else {
                dispatch(addressSelectionFailed(addressId));
              }
            }
            _context2.next = 20;
            break;
          case 5:
            stateObjectName = addressSearchInputId || 'addressSearch';
            apiKey = (0, _get["default"])(getState(), "".concat(stateObjectName, ".apiKey"), '');
            params = _objectSpread({
              Key: apiKey,
              Id: id
            }, jlpid && getJlpid(jlpid));
            url = (0, _endpointConstants.URL_LOQATE_ADDRESS_SELECT)(params);
            networkTimeoutDispatch = setTimeout(function () {
              dispatch({
                type: "".concat(prefix).concat(_addressSearchActionConstants.LOQATE_ADDRESS_SELECT, ".NETWORK_TIMEOUT")
              });
              onLoqateNetworkTimeoutCallback(url);
            }, 3000);
            _context2.next = 12;
            return selectLoqateAddress(params);
          case 12:
            response = _context2.sent;
            clearTimeout(networkTimeoutDispatch);
            _context2.next = 16;
            return response.json();
          case 16:
            json = _context2.sent;
            items = (0, _get["default"])(json, 'Items');
            onLoqateSearchCallback(response, "".concat(addressId, "_").concat(_addressSearchActionConstants.LOQATE_ADDRESS_SELECT, ".FAILED"), json);
            if (!items || getLoqateError(items)) {
              dispatch(addressSelectionFailed(addressId));
            } else {
              _address = items[0];
              _isValid = true;
              if (typeof validateLoqateAddress === 'function') {
                _isValid = validateLoqateAddress(_address);
              }
              if (_isValid) {
                dispatch({
                  type: "".concat(prefix).concat(_addressSearchActionConstants.LOQATE_ADDRESS_SELECT, ".SUCCESS")
                });
                dispatch((0, _addressActions.selectAddress)({
                  addressId: addressId,
                  address: (0, _address2.mapLoqateAddressValuesToAddress)(_address, combineExtraAddressLines),
                  replaceGbTerritoryCountryCodes: replaceGbTerritoryCountryCodes
                }));
              } else {
                dispatch(addressSelectionFailed(addressId));
              }
            }
          case 20:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var setLoqateApiKey = exports.setLoqateApiKey = function setLoqateApiKey(apiKey) {
  return {
    type: _addressSearchActionConstants.SET_LOQATE_API_KEY,
    apiKey: apiKey
  };
};